module.exports = __webpack_public_path__ + "img/Logo.027b4c6f.png";